export const GET_VENDORS_LIST = 'GET_VENDORS_LIST';
export const GET_VENDOR = 'GET_VENDOR';
export const DELETE_VENDOR = 'DELETE_VENDOR';

export function getVendorsList(data) {
  return {
    type: GET_VENDORS_LIST,
    payload: data,
  }
}

export function getVendor(data) {
  return {
    type: GET_VENDOR,
    payload: data,
  }
}

export function deleteVendor(data) {
  return {
    type: DELETE_VENDOR,
    payload: data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/vendors/index.js